import { Component } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import Button from "./ui/Button";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[50vh] flex items-center justify-center p-6">
          <div className="text-center max-w-md">
            <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-4">
              <AlertTriangle size={32} className="text-red-500" />
            </div>
            <h2 className="text-lg font-bold text-neutral-900 mb-2">
              Something went wrong
            </h2>
            <p className="text-sm text-neutral-500 mb-6">
              {this.state.error?.message ||
                "An unexpected error occurred. Please try again."}
            </p>
            <Button onClick={this.handleRetry}>
              <RefreshCw size={16} className="mr-2" /> Try Again
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
